import { FiltriAllegati } from '../filtri-allegati.model';

/**Interfaccia che rappresenta lo stato della sezione allegati */
export interface State {
    /**Sezione di Allegati attualmente visualizzata: none | bio | files */
    currentSection: string;
    /**Eventuali filtri applicati alla sezione */
    filters: FiltriAllegati;
}

/**Stato iniziale per gli allegati */
export const initialState: State = {} as State;